import fileSys from "../../fileoprators/fileSystem";
import { delMediaFiles, uploadFiles } from "../../services/media";
import { PAGES, RINGNUMBER, TOPOGRAPHYMODES } from "../../shared/consts";
import { getSystemTime, isDefined, isFunction } from "../../shared/utils";
import CaseHandle from "./CaseHandle";
function getBatchNo() {
  let now = parseInt(Date.now() / 1000);
  let start = parseInt(new Date("1970-01-01").valueOf() / 1000);
  return now - start;
}
class TopographyProc {
  init(pat, record, mode, media, eyetype, pupilcornea) {
    this.currPatient = pat;
    this.imagePath = media.imagePath;
    this.videoPath = media.videoPath;
    this.mode = mode;
    this.eyeType = eyetype;
    this.record = record;
    this.osod = `data${eyetype}`;
    this.pupilCornea = pupilcornea;

    this.item = {
      filePath: fileSys.getFileBaseName(media.imagePath),
      eyetype: eyetype,
      ringnum: RINGNUMBER
    };
    if (!isDefined(this.record)) {
      this.record = {
        patientid: pat._id,
        checktype: "topography",
        content: {
          dataOD: {
            batchNo: getBatchNo(),
            diagnosed: false
          },
          dataOS: {
            batchNo: getBatchNo(),
            diagnosed: false
          }
        }
      };
    }
  }
  initRecord(mode) {
    let _mode = isDefined(mode) ? mode : this.mode;
    this.record["eyetype"] = this.record["eyetype"] || [];
    if (this.record["eyetype"].indexOf(this.eyeType) < 0) {
      this.record["eyetype"].push(this.eyeType);
    }
    let tt = getSystemTime();
    this.record.testtime = tt;
    this.record.content[this.osod] = this.record.content[this.osod] || {};
    this.record.content[this.osod].diagnosed = true;
    this.record.content[this.osod][_mode] = this.record.content[this.osod][_mode] || {};
    this.record.content[this.osod][_mode].uploaded = false;
    this.record.content[this.osod][_mode].diagnosed = true;
    this.record.content[this.osod][_mode].testtime = tt;
    this.record.content[this.osod][_mode].photos = [];
  }
  emitRecord(err, callback) {
    let cmd = isDefined(this.record._id) ? "updateRecord" : "addRecord";
    if (isFunction(callback)) {
      callback(err, cmd, this.record);
    }
  }
  initPupilCornea(mode, key) {
    let obj = CaseHandle.calcPupilCornea(this.imagePath);

    let { x, y, r } = window.ctShotInfo.centerPoint;
    let pupil = obj.pupil || {
      x: x * 2,
      y: y * 2,
      r: parseFloat(r)
    };
    let cornea = obj.cornea || {
      x: x * 2,
      y: y * 2,
      r: parseFloat(r)
    };
    this.record.content[this.osod][mode][key] = this.record.content[this.osod][mode][key] || {};
    this.record.content[this.osod][mode][key].edge = key === "pupildia" ? pupil : cornea;
    this.record.content[this.osod][mode][key].edgeMoved = {
      x: -1000,
      y: -1000,
      r: -1000
    };
  }
  initPupilCorneaVideo(mode, callback) {
    CaseHandle.calcPupilCorneaVideo(this.videoPath, (data) => {
      if (!data.result) {
        callback({ result: data.result, error: data.result });
      } else {
        this.record.content[this.osod][mode]["pupilArray"] = data.res;

        callback(data);
      }
    });
  }
  deletePhotos(photos, callback) {
    delMediaFiles(photos, () => {
      if (isFunction(callback)) {
        callback();
      }
    });
  }
  beforeUpdate(mode, callback) {
    if (isDefined(this.record._id)) {
      if (isDefined(this.record.content[this.osod])) {
        if (isDefined(this.record.content[this.osod][mode])) {
          let photos = this.record.content[this.osod][mode]["photos"] || [];
          this.deletePhotos(photos.concat(), () => {
            this.record.content[this.osod][mode] = {};
            this.record.content[this.osod][mode]["photos"] = [];
            if (isFunction(callback)) {
              callback();
            }
          });
        } else {
          if (isFunction(callback)) {
            callback();
          }
        }
      } else {
        if (isFunction(callback)) {
          callback();
        }
      }
    } else {
      if (isFunction(callback)) {
        callback();
      }
    }
  }
  procPupilCorneaDiameter(pupilCornea, callback) {
    this.beforeUpdate(pupilCornea, () => {
      this.initRecord(pupilCornea);
      if (pupilCornea === "pupilcorneadia_dynamic") {
        this.initPupilCorneaVideo(pupilCornea, () => {
          let err;
          console.log(
            "procPupilCorneaDiameter:imagepath",
            this.pupilCornea === "pupilcorneadia_dynamic"
              ? fileSys.isFileExists(this.videoPath)
              : fileSys.isFileExists(this.imagePath)
          );
          uploadFiles(
            [this.pupilCornea === "pupilcorneadia_dynamic" ? this.videoPath : this.imagePath],
            [],
            (data) => {
              if (data.message === "proc") return;
              if (data.message === "OK") {
                let fileinfo = data.fileInfos[0];
                let _mode = isDefined(pupilCornea) ? pupilCornea : this.mode;
                this.record.content[this.osod][_mode]["photos"][0] = fileinfo;
              } else {
                err = new Error("upload file error");
              }
              this.emitRecord(err, callback);
            }
          );
        });
      } else {
        this.initPupilCornea(pupilCornea, "pupildia");
        this.initPupilCornea(pupilCornea, "corneadia");
        let err;
        console.log(
          "procPupilCorneaDiameter:imagepath",
          this.pupilCornea === "pupilcorneadia_dynamic"
            ? fileSys.isFileExists(this.videoPath)
            : fileSys.isFileExists(this.imagePath)
        );
        uploadFiles(
          [this.pupilCornea === "pupilcorneadia_dynamic" ? this.videoPath : this.imagePath],
          [],
          (data) => {
            if (data.message === "proc") return;
            if (data.message === "OK") {
              let fileinfo = data.fileInfos[0];
              let _mode = isDefined(pupilCornea) ? pupilCornea : this.mode;
              this.record.content[this.osod][_mode]["photos"][0] = fileinfo;
            } else {
              err = new Error("upload file error");
            }
            this.emitRecord(err, callback);
          }
        );
      }
    });
  }
  procData(callback) {
    switch (this.mode) {
      case PAGES.topography:
        this.initRecord(this.mode);

        CaseHandle.onTakePhoto(
          this.currPatient,
          this.record,
          this.osod,
          this.mode,
          this.imagePath,
          this.item,
          callback
        );

        break;
      case TOPOGRAPHYMODES.pupilcorneadia.key:
        this.procPupilCorneaDiameter(this.pupilCornea, callback);
        break;
      default:
        break;
    }
  }
  getRecord(record, eyetype) {
    return new Promise((resolve, reject) => {
      CaseHandle.getCase(record, false, false, eyetype, (casepath) => {
        if (!casepath) reject(new Error("get-case-error"));
        else resolve(casepath);
      });
    });
  }
}
export default TopographyProc;



// WEBPACK FOOTER //
// ./src/topography/js/TopographyRecordProc.js